document.addEventListener('DOMContentLoaded', () => {
  const KEY = 'w4p_compare';
  const MAX = parseInt(tray.getAttribute('data-max') || '4', 10);
  const tray = document.querySelector('[data-compare-tray]');
  const overlay = document.querySelector('[data-compare-overlay]');
  if (!tray || !overlay) return;
  const countEl = tray.querySelector('[data-compare-count]');
  const tableWrap = overlay.querySelector('[data-compare-table]');
  const money = (cents) => '$' + (cents / 100).toFixed(2);

  const get = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } };
  const set = (arr) => localStorage.setItem(KEY, JSON.stringify(arr));

  function syncUI() {
    const items = get();
    document.querySelectorAll('[data-compare-toggle]').forEach((btn) => {
      btn.classList.toggle('is-active', items.includes(btn.getAttribute('data-compare-toggle')));
    });
    tray.hidden = items.length < 2;
    countEl.textContent = items.length + ' product' + (items.length === 1 ? '' : 's') + ' to compare';
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-compare-toggle]');
    if (btn) {
      const handle = btn.getAttribute('data-compare-toggle');
      let items = get();
      if (items.includes(handle)) { items = items.filter((h) => h !== handle); }
      else {
        if (items.length >= MAX) { alert('You can compare up to ' + MAX + ' products.'); return; }
        items.push(handle);
      }
      set(items); syncUI(); return;
    }
    if (e.target.closest('[data-compare-clear]')) { set([]); syncUI(); return; }
    if (e.target.closest('[data-compare-open]')) { openCompare(); return; }
    if (e.target.closest('[data-compare-close]') || e.target === overlay) { overlay.classList.remove('is-open'); document.body.style.overflow = ''; }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && overlay.classList.contains('is-open')) { overlay.classList.remove('is-open'); document.body.style.overflow = ''; } });

  function openCompare() {
    const items = get();
    if (items.length < 2) return;
    tableWrap.innerHTML = '<p class="qv-loading">Loading…</p>';
    overlay.hidden = false; overlay.classList.add('is-open'); document.body.style.overflow = 'hidden';
    Promise.all(items.map((h) => fetch('/products/' + h + '.js').then((r) => r.json())))
      .then((products) => {
        const row = (label, fn) =>
          '<tr><th>' + label + '</th>' + products.map((p) => '<td>' + fn(p) + '</td>').join('') + '</tr>';
        tableWrap.innerHTML =
          '<table class="compare-table"><tbody>' +
          row('', (p) => p.featured_image ? '<a href="/products/' + p.handle + '"><img src="' + p.featured_image + '" alt="" loading="lazy"></a>' : '') +
          row('Product', (p) => '<a href="/products/' + p.handle + '"><b>' + p.title + '</b></a>') +
          row('Brand', (p) => p.vendor) +
          row('Price', (p) => '<span class="price">' + money(p.price) + '</span>') +
          row('Availability', (p) => p.available ? 'In stock' : 'Sold out') +
          row('', (p) => p.available
            ? '<form method="post" action="/cart/add"><input type="hidden" name="id" value="' + p.variants[0].id + '"><button class="button primary" type="submit">Add to cart</button></form>'
            : '<span>Sold out</span>') +
          '</tbody></table>';
      })
      .catch(() => { tableWrap.innerHTML = '<p class="qv-loading">Sorry, comparison could not be loaded.</p>'; });
  }
  syncUI();
});
